import store from '../store';
import axios from 'axios';

import { setRefreshToken } from '@/auth/services';

// To Persistance
import { Persistance } from '@/common';

axios.interceptors.request.use(
  function(config) {
    let token = Persistance.getPersistedVar('AccessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      config.headers['Content-Type'] = `application/json`;
    }
    return config;
  },
  function(err) {
    return Promise.reject(err);
  },
);


axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const {
      config,
      response: { status },
    } = error;
    const refreshToken = Persistance.getPersistedVar('RefreshToken');
    if (status === 401 && refreshToken) {
        Persistance.remove('AccessToken');
        const { access_token } = await setRefreshToken({ refreshToken });
        Persistance.persistValue('AccessToken', access_token);
        const retryOrigReq = await subscribeTokenRefresh(config, access_token);
        return retryOrigReq;
    } else {
      if (!refreshToken) {
        store.dispatch('user/logout');
      }
      return Promise.reject(error);
    }
  },
);

function subscribeTokenRefresh(config, token) {
  return new Promise((resolve, reject) => {
    const originalRequest = config;
    originalRequest.headers['Authorization'] = 'Bearer ' + token;
    resolve(axios(originalRequest));
  });
}
